<template>
  <div class="change-value">
    <span
      v-if="data.fieldauth === 1"
      class="fs-warning sensitive"
    >{{ $t('message["345"]') }}</span>
    <span
      v-else-if="data.isdeletefield"
      class="value fs-warning"
    >{{ $t('message["332"]') }}</span>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'tag' && data.fieldvalue && $toType(data.fieldvalue) === 'string'"
      class="tags"
    >
      <span
        v-for="(item, i) in data.fieldvalue.split(',')"
        :key="i"
        class="tag"
      >{{ item }}</span>
    </div>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'file' && data.fieldvalue && $toType(data.fieldvalue) === 'array'"
      class="file-list"
    >
      <a
        v-for="(file, i) in data.fieldvalue"
        :key="i"
        class="file textOverflow"
        @click="handleclickGallery(data.fieldvalue, i)"
      >{{ file.file_name }}</a>
    </div>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'editor'"
      class="editor quill-editor"
    >
      <div
        class="html ql-editor"
        v-html="$xss(data.fieldvalue, $xssOptions)"
      />
    </div>

    <div
      v-else-if="valueKey === 'dev_userid'"
      class="value"
    >
      <span v-if="!data.fieldvalue || !data.fieldvalue.length || data.fieldvalue === '[]'">- -</span>
      <span v-else>{{ data.fieldvalueData.dev_truename }}<i class="fs-gray"> [{{ data.fieldvalueData.dev_rolename }}<em v-if="data.fieldvalueData.dev_groupname">/ {{ data.fieldvalueData.dev_groupname }}</em>]</i></span>
    </div>
    <span
      v-else
      class="value"
    >{{ (!data.fieldvalue || !data.fieldvalue.length) ? '- -' : data.fieldvalue }}</span>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    historyType: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: ''
    }
  },

  watch: {
    data (val) {
      this.setFile()
    }
  },
  mounted () {
    this.setFile()
  },

  methods: {
    setFile () {
      let fieldtype = this.data[this.historyType + 'fieldtype']
      let { fieldvalue } = this.data

      if (fieldtype === 'file' && fieldvalue && this.$toType(fieldvalue) === 'array') {
        fieldvalue.forEach(file => {
          file.description = file.name || file.file_name
          file.href = file.file_url
          // file.href = '//westartrack-file.test.upcdn.net/images/78bd925f50g4039bc0b1cq82dff12f36.png?_upt=e5255db81592478130'
          file.title = '下载'
        })
      }
    },
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: '是否下载？',
          okText: '确定',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.change-value {
  float: left;
  width: 250px;
  padding-left: 16px;
  padding-right: 12px;
  word-break: break-all;
  .value {
    line-height: 24px;
    i, em {
      font-style: normal;
    }
  }
}
.sensitive {
  font-size: 12px;
  line-height: 24px;
}
.tags {
  padding: 4px 0;
  .tag {
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 12px;
    padding: 2px 4px;
    line-height: 1.2;
    font-size: 12px;
    color: $gray2;
    border: solid 1px $gray4;
    border-radius: 4px;
  }
}
.editor ::v-deep {
  width: 224px;
  border-radius: 4px;
  border: solid 1px #d6d6d6;
  .html {
    height: 160px;
    padding: 8px 12px;
    overflow-y: scroll;
  }
  img {
    display: inline-block;
    max-width: 100%;
  }
}
.file-list {
  .file {
    display: block;
    width: 100%;
    margin: 5px 0;
  }
}
</style>
